export enum RoutePlanType {
  CONSOLIDATE = 'CONSOLIDATE',
  POOL_DISTRIBUTION = 'POOL_DISTRIBUTION',
  POOL_CONSOLIDATE = 'POOL_CONSOLIDATE',
  CROSS_DOCK = 'CROSS_DOCK',
  ZONE_SKIPPING = 'ZONE_SKIPPING',
}

export const NUM_CROSSDOCKS_BY_ROUTE_PLAN_TYPE: Record<RoutePlanType, number> =
  {
    CONSOLIDATE: 0,
    POOL_DISTRIBUTION: 1,
    POOL_CONSOLIDATE: 1,
    CROSS_DOCK: 1,
    ZONE_SKIPPING: 2,
  };
